const langAuthBarOktaBug = {
	message: {
		tag: 'auth.bar_okta_bug.message',
		fr: "Nous rencontrons des difficultés techniques concernant l'envoi d'e-mail d'authentification. Nous vous prions de nous excuser pour la gêne occasionnée et travaillons pour rétablir le service le plus vite possible.",
		en: 'We are facing an issue impacting emails delivery. We are sorry for the inconvienenced caused and are working to restore the service as soon as possible.',
	},
};

export default langAuthBarOktaBug;
